<template>
    <div class="form-data">
        <div class="frame -pt-4">
            <div class="form-check d-flex align-items-center">
                <input class="form-check-input" v-model="form.school" type="checkbox" :true-value="1" :false-value="0" id="w_szkole">
                <label class="form-check-label -pl-1 text-20" for="w_szkole">w szkole</label>
            </div>
            <div class="form-check d-flex align-items-center form__pt-24">
                <input class="form-check-input" v-model="form.librus" type="checkbox" :true-value="1" :false-value="0" id="z_librusa">
                <label class="form-check-label -pl-1 text-20" for="z_librusa">z Librusa</label>
            </div>
            <div class="form-check d-flex align-items-center form__pt-24">
                <input class="form-check-input" v-model="form.facebook" type="checkbox" :true-value="1" :false-value="0" id="z_facebooka">
                <label class="form-check-label -pl-1 text-20" for="z_facebooka">z Facebooka</label>
            </div>
            <div class="form-check d-flex align-items-center form__pt-24">
                <input class="form-check-input" v-model="form.instagram" type="checkbox" :true-value="1" :false-value="0" id="z_instagrama">
                <label class="form-check-label -pl-1 text-20" for="z_instagrama">z Instagrama</label>
            </div>
            <div class="form-check d-flex align-items-center form__pt-24">
                <input class="form-check-input" v-model="form.tiktok" type="checkbox" :true-value="1" :false-value="0" id="z_tiktoka">
                <label class="form-check-label -pl-1 text-20" for="z_tiktoka">z TikToka</label>
            </div>
            <div class="form-check d-flex align-items-center form__pt-24">
                <input class="form-check-input" v-model="form.youtube" type="checkbox" :true-value="1" :false-value="0" id="z_youtube">
                <label class="form-check-label -pl-1 text-20" for="z_youtube">z YouTube</label>
            </div>
            <div class="form-check d-flex align-items-center form__pt-24">
                <input class="form-check-input" v-model="form.radio" type="checkbox" :true-value="1" :false-value="0" id="radio">
                <label class="form-check-label -pl-1 text-20" for="radio">z radia</label>
            </div>
            <div class="form-check d-flex align-items-center form__pt-24">
                <input class="form-check-input" v-model="form.mailing" type="checkbox" :true-value="1" :false-value="0" id="mailing">
                <label class="form-check-label -pl-1 text-20" for="mailing">z mailingu</label>
            </div>
            <div class="form-check d-flex align-items-center form__pt-24">
                <input class="form-check-input" v-model="form.friend" type="checkbox" :true-value="1" :false-value="0" id="frend">
                <label class="form-check-label -pl-1 text-20" for="frend">od znajomego lub rodziny</label>
            </div>
            <div class="form-check d-flex align-items-center form__pt-24">
                <input class="form-check-input" v-model="form.other" type="checkbox" :true-value="1" :false-value="0" id="flexCheckDefault">
                <label class="form-check-label -pl-1 text-20" for="flexCheckDefault">inne (należy wskazać jakie)</label>
            </div>
            <text-input class="form__pt-24 col-sm-12" v-if="form.other" v-model="form.other_text" :data="inputs.other_text" :errors="errors" />
        </div>
    </div>
</template>

<script>
import TextInput from "@/components/inputs/TextInput.vue";


export default {
    emits: ['update:modelValue', 'type'],
    props: ['errors', 'modelValue'],
    data() {
        return {
            inputs: {
                other_text: {
                    type: 'text',
                    title: 'Wskaż miejsce',
                    placeholder: 'Wskaż miejsce',
                    mandatory: '*',
                    subtitle: null,
                    model: 'other_text',
                    stage: 'formStudent.student.how_know.other_text'
                },

            },
            form: {
                school: 0,
                librus: 0,
                facebook: 0,
                instagram: 0,
                tiktok: 0,
                youtube: 0,
                radio: 0,
                mailing: 0,
                friend: 0,
                other: 0,
                other_text: '',
            }
        }
    },
    components: {
        TextInput
    },
    computed: {
    },
    watch: {
        form: {
            handler(newVal) {
                this.$emit('update:modelValue', newVal)
                this.updateFormValue('formStudent.student.how_know', newVal);
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
    },
};
</script>
